import React from 'react'
import Logo from '../../assets/image/logo/logowhite.png';
import { LinearProgress } from '@mui/material';

const MaskLoader = () => {
    return (
        <div className='w-[100vw] h-[100vh] absolute bg-black z-[9] flex  justify-center items-center ' >
            <div>
                <img src={Logo}  width={200} />
                <br />
                <LinearProgress />
            </div>
        </div>
    )
}

export default MaskLoader